import axios from 'axios';

const convertToKebabCase = (string) => {
  return string.replace(/\s+/g, '-').toLowerCase();
};
///globalassets/fleet/National-Geographic-Endurance/deckplans/expedition-deck.svg
///globalassets/fleet/national-geographic-explorer/deck-plans/b-deck/plan/b-deck.svg

export const GetSvgByName = async (deck: string, ship: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        '/globalassets/fleet/' +
        convertToKebabCase(ship) +
        '/deck-plans/' +
        convertToKebabCase(deck) + '/plan/' +
        convertToKebabCase(deck) + '.svg',
      )
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

export const GetSvgByUrl = async (url): Promise<string> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};
